import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import Modal from 'react-modal';
import 'react-image-lightbox/style.css';
import { get } from 'lodash';
class Gallery extends PureComponent {

  state = {
    photoIndex: 0,
    isOpen: false,
  };

  componentDidMount() {
    Modal.setAppElement('body');
  }

  preparePhotosData = (photos) => {
    if (!photos) return null;
    return photos.map((photo) => ({
      url: get(photo, ['file', 'url']),
      thumbUrl: get(photo, ['file', 'thumb', 'url']),
      id: get(photo, 'id'),
    }));
  }

  renderSlides = (preparedPhotos) => {
    if (!preparedPhotos) return null;

    return preparedPhotos.map((preparedPhoto, index) => {
      const { thumbUrl, id } = preparedPhoto;
      return (
        <span
          key={id}
          style={{ padding: '0 15px' }}
        >
          <img
            onClick={() => {
              this.setState({
                isOpen: true,
                photoIndex: index,
              });
            }}
            src={thumbUrl}
            alt={`moto ${index}`}
            style={{
              cursor: 'pointer',
              height: '60px',
              width: '60px',
              borderRadius: '5px',
              margin: '0 auto',
            }}
          />
        </span>
      );
    });
  };

  renderLightbox = (preparedPhotos, photoIndex) => {
    const preparedPhotosLength = preparedPhotos.length;
    const prevPhotoIndex = (photoIndex + preparedPhotosLength - 1) % preparedPhotosLength;
    const nextPhotoIndex = (photoIndex + 1) % preparedPhotosLength;
    return (
      <Lightbox
        mainSrc={preparedPhotos[photoIndex].url}
        nextSrc={preparedPhotos[nextPhotoIndex].url}
        prevSrc={preparedPhotos[prevPhotoIndex].url}
        mainSrcThumbnail={preparedPhotos[photoIndex].thumbUrl}
        nextSrcThumbnail={preparedPhotos[nextPhotoIndex].thumbUrl}
        prevSrcThumbnail={preparedPhotos[prevPhotoIndex].thumbUrl}
        onCloseRequest={() => this.setState({ isOpen: false })}
        onMovePrevRequest={() =>
          this.setState({
            photoIndex: prevPhotoIndex,
          })}
        onMoveNextRequest={() =>
          this.setState({
            photoIndex: nextPhotoIndex,
          })}
      />
    );
  }


  render() {
    const { photoIndex, isOpen } = this.state;
    const { photos } = this.props;
    const preparedPhotos = this.preparePhotosData(photos);
    const thumbnailsOfPhotos = this.renderSlides(preparedPhotos);

    return (
      <div>
        <div className="row">
          <div className="col-md-9 col-centered details__thumbs">
            {thumbnailsOfPhotos}
          </div>
        </div>
        {isOpen && this.renderLightbox(preparedPhotos, photoIndex)}
      </div>
    );
  }
}

export default Gallery;
